<div class="browseFundraiser">
  <!-- ais-instantsearch is the root component for all the algolia widgets -->
  <ais-instantsearch [config]="instantSearchConfig">
    <ais-configure [searchParameters]="{ hitsPerPage: 9, query: query }"></ais-configure>

    <!-- Fundraiser filter is for the filter component included only for Mobile -->
    <app-fundraiser-filter [filterData]="filterValues" [hidden]="!toggleFilterComponent" *ngIf="isMobile"
      (toggleFilterComponent)="toggleFilterFunction($event)" class="filter-component"></app-fundraiser-filter>

    <!-- Code to display browse placeholder on load -->
    <ais-infinite-hits>
      <ng-template let-hits="hits">
        <app-browse-placeholder *ngIf="checkData(hits) && showPlaceholder && hits.length === 0"
          [isMobile]="isMobile"></app-browse-placeholder>
      </ng-template>
    </ais-infinite-hits>

    <div [hidden]="showPlaceholder" class="banner">
      <app-browse-banner [user]="user"></app-browse-banner>
    </div>

    <div [hidden]="showPlaceholder" class="searchContainer">
      <div *ngIf="!isMobile" class="secLeft">
        <div class="categoryContainer">
          <app-category-filters [filterData]="filterValues" (askLogin)="openLoginPopup($event)" />
        </div>
      </div>
      <div class="secRight">
        <app-widget-wrapper
          [widgetData]="fundraisers"
          [filterData]="filterValues"
          [currency]="currency"
          [isMobile]="isMobile"
          (toggleFilterComponent)="toggleFilterFunction($event)"
          (askLogin)="openLoginPopup($event)"
        />
      </div>
    </div>

    <div *ngIf="!isMobile" class="chatWrap">
      <app-chat-with-us
        [html]="'Have a question? Check out our <a href=https://customerhappiness.ketto.org/portal/en/kb target=_blank>FAQs</a> page or chat with us on Facebook or WhatsApp now.'"
        fbposition='15' whatsposition='16' pageName='browse_fundraiser' [hidden]="showPlaceholder" />
    </div>


  </ais-instantsearch>

</div>




<app-signin-signup [popupView]="true" [numberOnly]="true" [showPopup]="loginPopupState" [noRedirectAfterLogin]="true" (onClose)="signinClosed($event)" />


<app-sip-dock *ngIf="!user?.listsubscriptions?.medical"></app-sip-dock>